































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Iso19030Help extends Vue {
  tab: string | null = null;
}
